export const CINDEDI_ERROR_ID = Symbol.for('@cindedi/error:identifier');
